<template>
  <Utp />

  <Characteristic />
</template>

<script>
import Characteristic from "../Characteristic/Characteristic.vue";
import Utp from "../DetailsBlock/DetailsBlock";
import { mapState } from "pinia";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
export default {
  name: "CharacteristicBlock",
  components: {
    Characteristic,
    Utp,
  },
  computed: {
    ...mapState(useProductStore, ["getFeaturesList"]),
  },
};
</script>
